import styles from './FormLabel.module.scss';

type Props = {
  children: React.ReactNode;
  dataTestId?: string;
  htmlFor?: string;
};

function FormLabel({ children, dataTestId, htmlFor }: Props) {
  return (
    <div className={styles.componentStyle}>
      <label data-testid={dataTestId} htmlFor={htmlFor}>
        {children}
      </label>
    </div>
  );
}
export default FormLabel;
